export default __webpack_public_path__ + "icon-chevron-left.4af8b064.png";